/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from '@angular/core';
import { Gtag } from 'angular-gtag';
import { Router } from '@angular/router';
import { free, planner } from '../../common/pricing/products';

@Component({
    selector: 'app-pricing',
    templateUrl: './pricing.component.html',
    styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit {

    public freeProduct = free;
    public plannerProduct = planner;

    constructor(private readonly router: Router,
                private readonly gtag: Gtag) {}

    public ngOnInit(): void {
        this.gtag.pageview({
            page_title: 'Pricing',
            page_path: '/pricing',
            page_location: 'https://deckplan.io/'
        });
    }

    public signUpClicked(isPlanner: boolean) {
        this.router.navigate(['/signup', {isPlanner}]);
    }
}
